// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TippyPopupStyle } from "@hardwoods/App/Components/Tippy/Interface";
import Close from "@hardwoods/XDL/Icons/Close";
import { color } from "@hardwoods/XDL/Utilities";
import { xScreen } from "@hardwoods/XDL/Utilities/MediaQuery";
import { css } from "styled-components";

// To add hardwoods style
const hardwoodsStyle = css``;

const mobileStyle = css`
    ${xScreen.lte("sm")} {
        div[data-tippy-root] {
            position: fixed !important;
            height: 100vh;
            left: 0 !important;
            right: unset !important;
            top: 0;
            bottom: 0;
            transform: translate3d(0, 0, 0) !important;
            width: 80%;
            max-width: 500px;
            min-width: 300px;
        }

        .tippy-content {
            background: ${color("common.white")};
            height: 100vh;
        }
    }
    ${xScreen.lt("sm")} {
        .tippy-content {
            padding: 0;
            & > div {
                height: 100%;
            }
        }
    }
`;

export const tippyPopupStyles: TippyPopupStyle = {
    main: {
        css: css`
            .tippy-box {
                transition-duration: 500ms !important;
                background-color: ${color("common.white")};
                color: ${color("text.main")};
                border-radius: 0 0 4px 4px;
                box-shadow: inset 0 6px 0 0 ${color("primary.dark")}, 0 2px 4px 0 ${color("common.black", 0.25)};

                &:focus,
                & > *:focus {
                    outline: none;
                }
            }

            .tippy-box > .tippy-content {
                border-radius: 0 0 4px 4px;
                padding: 22px;
            }

            .without-border .tippy-box > .tippy-content {
                border-top: 0;
                &:before {
                    display: none;
                }
            }

            .tippy-box.no-padding > .tippy-content {
                padding: 0;
            }

            .tippy-box > .tippy-arrow {
                color: ${color("common.brand4")};
                // icon-size
                &::before {
                    transform: scale(1.5, 1.3);
                }
            }

            ${(props: any) => (props.enableMobileMode ? mobileStyle : "")}

            ${hardwoodsStyle}
        `,
    },
    elementWrapper: { outline: "none !important" },
    closeButton: {
        src: Close,
        size: 12,
        css: css`
            position: absolute;
            right: 10px;
            top: 10px;
            z-index: 999;
            &:hover {
                color: ${color("danger")};
            }

            &.on-mobile {
                ${xScreen.gt("md")} {
                    display: none;
                }
            }
        `,
    },
};
